import { CheckCircle, XCircle } from 'lucide-react';
import type { GS1Data } from '../../utils/gs1Parser';

interface Props {
  data: GS1Data | null;
}

function formatDate(d: Date | null): string {
  if (!d) return '-';
  const dd = String(d.getDate()).padStart(2, '0');
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const yyyy = d.getFullYear();
  return `${dd}/${mm}/${yyyy}`;
}

export function ParsedDataDisplay({ data }: Props) {
  if (!data) {
    return (
      <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-5">
        <h2 className="text-lg font-semibold text-gray-800 mb-3">Dados Parseados</h2>
        <p className="text-sm text-gray-400 italic">Clique em &quot;Parsear&quot; para processar o codigo</p>
      </div>
    );
  }

  const fields = [
    { label: 'GTIN', value: data.gtin, extra: data.gtin ? (
      <span className="ml-2 inline-flex items-center gap-1">
        {data.gtinValid ? (
          <><CheckCircle className="w-4 h-4 text-green-500" /><span className="text-xs text-green-600">Checksum OK</span></>
        ) : (
          <><XCircle className="w-4 h-4 text-red-500" /><span className="text-xs text-red-600">Checksum Invalido</span></>
        )}
      </span>
    ) : null },
    { label: 'Lote (AI 10)', value: data.lote },
    { label: 'Validade (AI 17)', value: formatDate(data.validade) },
    { label: 'Serial (AI 21)', value: data.serie },
    { label: 'Data Producao (AI 11)', value: formatDate(data.dataProducao) },
    { label: 'Melhor Uso (AI 15)', value: formatDate(data.melhorUso) },
    { label: 'Quantidade (AI 30/37)', value: data.quantidade?.toString() ?? null },
    { label: 'Ref Code (AI 240)', value: data.refCode },
  ];

  return (
    <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-5">
      <h2 className="text-lg font-semibold text-gray-800 mb-3">Dados Parseados</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {fields.map((f) => (
          <div key={f.label} className="bg-gray-50 rounded-lg px-4 py-2.5">
            <p className="text-xs text-gray-500 font-medium">{f.label}</p>
            <p className="text-sm font-mono text-gray-800 flex items-center">
              {f.value || <span className="text-gray-300">-</span>}
              {'extra' in f && f.extra}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}
